import AdminApi from 'api/AdminApi';
import AdvisorApi from 'api/AdvisorApi';
import AnswersApi from 'api/AnswersApi';
import ControlsDataApi from 'api/ControlsDataApi';
import DocumentsApi from 'api/DocumentsApi';
import EmployerApi from 'api/EmployerApi';
import GuideApi from 'api/GuideApi';
import MiscApi from 'api/MiscApi';
import OriginatorApi from 'api/OriginatorApi';
import ParticipantsApi from 'api/ParticipantsApi';
import QInstancesApi from 'api/QInstancesApi';
import QuestionnairesApi from 'api/QuestionnairesApi';
import StripeApi from 'api/StripeApi';
import TermsAndConditionsApi from 'api/TermsAndConditionsApi';
import UsersApi from 'api/UsersApi';

const api = {
    admin: AdminApi,
    advisor: AdvisorApi,
    answers: AnswersApi,
    controlsData: ControlsDataApi,
    documents: DocumentsApi,
    employer: EmployerApi,
    guide: GuideApi,
    misc: MiscApi,
    originator: OriginatorApi,
    participants: ParticipantsApi,
    qInstances: QInstancesApi,
    questionnaires: QuestionnairesApi,
    stripe: StripeApi,
    termsAndConditions: TermsAndConditionsApi,
    users: UsersApi,
};

export default api;
